export const STRATEGY_ALERTS = {
    "onManualCallReprogramed": function (json) {
        if (typeof onManualCallReprogramed === 'function') {
            onManualCallReprogramed(json.data);
        }
    },
    "onDisconnected": function (json) {
        if (typeof onDisconnected === 'function') {
            onDisconnected(json.data);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyAlerts.js